// extracted by mini-css-extract-plugin
module.exports = {"faq__empty-page":"EmptyPage_faq__empty-page__TtTpZ"};